var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgTabs = function SvgTabs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 15 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.174 2.3c.352-.352.829-.55 1.326-.55h2.456a1.875 1.875 0 0 1 1.564.84l.508 1.379a.625.625 0 0 0 .528.281H12.5a1.875 1.875 0 0 1 1.875 1.875v5.625a1.875 1.875 0 0 1-1.875 1.875h-10A1.875 1.875 0 0 1 .625 11.75V3.625c0-.497.198-.974.55-1.326ZM2.5 3a.625.625 0 0 0-.625.625v8.125a.625.625 0 0 0 .625.625h10a.624.624 0 0 0 .625-.625V6.125A.625.625 0 0 0 12.5 5.5H7.565a1.875 1.875 0 0 1-1.579-.84L5.478 3.28A.625.625 0 0 0 4.956 3H2.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 2.375c0-.345.28-.625.625-.625h2.456a1.876 1.876 0 0 1 1.564.84l1.133 1.379a.625.625 0 0 0 .229.208.625.625 0 0 1-.588 1.103 1.876 1.876 0 0 1-.683-.62L11.103 3.28A.626.626 0 0 0 10.581 3H8.125a.625.625 0 0 1-.625-.625Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabs);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;